import "./language-switcher-v2.css";

const STORAGE_KEY = "carthy-language";

const translations = new Map([
  ["Navigation principale", "Main navigation"],
  ["Retour en haut", "Back to top"],
  ["Retour à l’accueil", "Back to home"],
  ["Ouvrir le menu", "Open menu"],
  ["Fermer le menu", "Close menu"],
  ["Produits", "Products"],
  ["Explorer l’intérieur", "Explore the interior"],
  ["Lire la vidéo", "Play video"],
  ["Pause", "Pause"],
  ["Reprendre au défilement", "Resume scroll control"],
  ["Lecture de la vidéo…", "Playing video…"],
  ["Choisissez une étape ou lancez la vidéo.", "Choose a step or play the video."],
  ["Fermer", "Close"],
  ["Réessayer", "Try again"],
  ["La vidéo n’a pas pu être chargée.", "The video could not be loaded."],
  ["Présentation du serveur rack 8 baies CARTHY", "CARTHY 8-bay rack server showcase"],
  ["Présentation de la tour GPU CARTHY", "CARTHY GPU tower showcase"],
  ["Présentation du serveur avec écran et clavier CARTHY", "CARTHY server with screen and keyboard showcase"],
  ["À l’intérieur de la tour", "Inside the tower"],
  ["La puissance GPU, vue de l’intérieur.", "GPU power, from the inside."],
  ["Faites défiler pour explorer la tour, de l’ouverture à la fermeture.", "Scroll to explore the tower, from opening to closing."],
  ["Découvrez la tour en mouvement.", "See the tower in motion."],
  ["La tour s’ouvre.", "The tower opens."],
  ["Les panneaux s’écartent pour dévoiler les composants et la structure du châssis.", "The panels move apart to reveal the components and the chassis structure."],
  ["La configuration se dévoile.", "The configuration is revealed."],
  ["La vue éclatée révèle les cartes graphiques et leur disposition à l’intérieur de la tour.", "The exploded view reveals the graphics cards and their layout inside the tower."],
  ["GPU", "GPU"],
  ["Au plus près du GPU.", "A closer look at the GPU."],
  ["La caméra s’approche d’une carte graphique entourée d’un halo d’énergie verte.", "The camera moves toward a graphics card surrounded by a green energy halo."],
  ["La tour reprend sa forme.", "The tower takes shape again."],
  ["La caméra revient en vue large et les panneaux se referment autour du châssis.", "The camera returns to a wide view as the panels close around the chassis."],
  ["Du clavier au cœur du serveur.", "From the keyboard to the heart of the server."],
  ["Clavier", "Keyboard"],
  ["Le clavier se déploie.", "The keyboard slides out."],
  ["Le tiroir coulisse vers l’avant tandis que la caméra révèle le serveur sous un nouvel angle.", "The drawer slides forward as the camera reveals the server from a new angle."],
  ["Le châssis révèle son intérieur.", "The chassis reveals its interior."],
  ["Le capot, le panneau latéral et la façade s’écartent pour dévoiler la carte mère.", "The lid, side panel and front fascia move apart to reveal the motherboard."],
  ["Mémoire", "Memory"],
  ["Au cœur de la carte mère.", "At the heart of the motherboard."],
  ["Un mouvement de caméra met en lumière la mémoire et le refroidissement du processeur.", "A camera move highlights the memory and CPU cooling."],
  ["Les panneaux retrouvent leur place, puis le clavier se rétracte dans le châssis.", "The panels return to their places, then the keyboard retracts into the chassis."],
  ["À l’intérieur du serveur", "Inside the server"],
  ["Chaque composant trouve sa place.", "Every component finds its place."],
  ["Faites défiler pour explorer le serveur, de l’ouverture à la fermeture.", "Scroll to explore the server, from opening to closing."],
  ["Découvrez le serveur en mouvement.", "See the server in motion."],
  ["Ouverture", "Opening"],
  ["Intérieur", "Interior"],
  ["Stockage", "Storage"],
  ["Fermeture", "Closing"],
  ["Le châssis s’ouvre.", "The chassis opens."],
  ["Une vue d’ensemble de l’intérieur.", "An overview of the interior."],
  ["Les huit disques prennent place.", "The eight drives move into place."],
  ["Le serveur se referme.", "The server closes."],
  ["Le capot et les tiroirs se séparent pour révéler la machine.", "The lid and trays separate to reveal the machine."],
  ["L’animation révèle l’organisation des composants dans le châssis.", "The animation reveals how the components are arranged inside the chassis."],
  ["Les tiroirs accueillent les disques avant leur retour en façade.", "The drives settle into the trays before they slide back into the front panel."],
  ["Les éléments retrouvent leur place et la silhouette du serveur se reforme.", "The components return to their places and the server takes shape again."],
  ["Animation de présentation.", "Showcase animation."],
  ["Aller au contenu", "Skip to content"],
  ["Produits CARTHY", "CARTHY products"],
  ["Le matériel", "Hardware by"],
  ["CARTHY.", "CARTHY."],
  ["Du format tour au serveur rack, découvrez nos équipements et échangeons sur la configuration adaptée à votre environnement.", "From towers to rack servers, explore our hardware and discuss the right configuration for your environment."],
  ["01 / Format tour", "01 / Tower format"],
  ["Tour GPU CARTHY", "CARTHY GPU tower"],
  ["Une station au format tour qui réunit plusieurs cartes graphiques et les composants de calcul dans un châssis sur roulettes.", "A tower workstation that brings multiple graphics cards and computing components together in a chassis on wheels."],
  ["Parler de la tour GPU CARTHY", "Discuss the CARTHY GPU tower"],
  ["Parler de ce produit", "Discuss this product"],
  ["Tour GPU CARTHY noire sur roulettes, avec son emblème vert et un éclairage de studio", "Black CARTHY GPU tower on wheels, with its green emblem and studio lighting"],
  ["Découvrir les formats rack", "Explore the rack formats"],
  ["Formats rack", "Rack formats"],
  ["Deux formats.", "Two formats."],
  ["Deux usages.", "Two uses."],
  ["Un accès direct par écran et clavier, ou huit baies de stockage en façade : choisissez le format qui répond à votre projet.", "Direct access through a screen and keyboard, or eight front storage bays: choose the format that suits your project."],
  ["Écran et clavier intégrés", "Integrated screen and keyboard"],
  ["Serveur rack avec écran et clavier", "Rack server with screen and keyboard"],
  ["Un ordinateur au format rack avec écran intégré et tiroir clavier coulissant, pour accéder directement à la machine.", "A rack computer with an integrated screen and sliding keyboard drawer for direct access to the machine."],
  ["Serveur CARTHY noir avec écran intégré et tiroir clavier ouvert, éclairé sur fond noir", "Black CARTHY server with an integrated screen and an open keyboard drawer, lit against a black background"],
  ["Parler du Serveur rack avec écran et clavier", "Discuss the rack server with screen and keyboard"],
  ["Huit baies en façade", "Eight front bays"],
  ["Serveur rack 8 baies CARTHY", "CARTHY 8-bay rack server"],
  ["Un serveur au format rack doté de huit tiroirs de disques en façade, pour réunir calcul et stockage dans un même châssis.", "A rack server with eight front drive trays, bringing computing and storage together in one chassis."],
  ["Serveur rack CARTHY avec huit tiroirs de disques et badge en façade, éclairé sur fond noir", "CARTHY rack server with eight drive trays and a front badge, lit against a black background"],
  ["Parler du Serveur rack 8 baies CARTHY", "Discuss the CARTHY 8-bay rack server"],
  ["Parlons de votre projet", "Let's talk about your project"],
  ["Trouvons votre configuration.", "Let's find your configuration."],
  ["Présentez-nous vos usages et votre environnement. Ensemble, précisons les équipements et les composants dont vous avez besoin.", "Tell us about your use cases and environment. Together, we can identify the equipment and components you need."],
  ["Pourquoi CARTHY", "Why CARTHY"],
  ["Conformité", "Compliance"],
  ["À propos", "About"],
  ["Planifier une rencontre", "Schedule a meeting"],
  ["Données sous contrôle", "Data under control"],
  ["Infrastructure, conformité et", "Infrastructure, compliance and"],
  ["IA privée", "private AI"],
  ["pour les entreprises", "for businesses"],
  ["CARTHY accompagne les organisations qui veulent sécuriser leur infrastructure informatique, répondre aux exigences SOC 2 et ISO 27001 et déployer une intelligence artificielle locale sans exposer leurs données sensibles.", "CARTHY helps organizations secure their IT infrastructure, meet SOC 2 and ISO 27001 requirements, and deploy local artificial intelligence without exposing sensitive data."],
  ["Découvrir nos services", "Discover our services"],
  ["Pensé pour les entreprises qui évoluent dans des environnements exigeants : finance, santé, technologie et opérations critiques.", "Designed for businesses operating in demanding environments: finance, healthcare, technology and critical operations."],
  ["Secteurs prioritaires", "Priority sectors"],
  ["Santé", "Healthcare"],
  ["Opérations critiques", "Critical operations"],
  ["Protection renforcée", "Enhanced protection"],
  ["Sécurisez vos systèmes et votre infrastructure sans perdre en agilité opérationnelle.", "Secure your systems and infrastructure without sacrificing operational agility."],
  ["Conformité structurée", "Structured compliance"],
  ["Avancez vers SOC 2 Type 2 et ISO 27001 avec une démarche claire et progressive.", "Move toward SOC 2 Type 2 and ISO 27001 with a clear, progressive approach."],
  ["Déployez une IA privée locale afin de conserver vos données stratégiques dans votre périmètre de sécurité.", "Deploy private local AI to keep your strategic data within your security perimeter."],
  ["Une approche conçue pour les environnements où le risque n'est pas une option", "An approach designed for environments where risk is not an option"],
  ["Les cybermenaces, les exigences réglementaires et la protection des données imposent une infrastructure plus robuste, mieux contrôlée et conforme aux standards reconnus du marché.", "Cyber threats, regulatory requirements and data protection demand a more resilient, better controlled infrastructure aligned with recognized industry standards."],
  ["Nos services", "Our services"],
  ["Des services pensés pour la sécurité, la conformité et la performance", "Services designed for security, compliance and performance"],
  ["Une offre structurée pour les entreprises qui ont besoin d'un partenaire capable d'intervenir à la fois sur la technologie, la gouvernance et l'évolution de leur environnement numérique.", "A structured offering for businesses that need a partner able to support technology, governance and the evolution of their digital environment."],
  ["Gestion d'infrastructure informatique", "IT infrastructure management"],
  ["Nous concevons, organisons et soutenons des environnements technologiques robustes adaptés aux réalités des PME et des grandes entreprises, avec un objectif de stabilité, de sécurité et d'efficacité opérationnelle.", "We design, organize and support robust technology environments tailored to the realities of SMEs and large enterprises, with a focus on stability, security and operational efficiency."],
  ["Abonnements et licences", "Subscriptions and licenses"],
  ["CARTHY intègre la gestion des licences à une vision globale de votre environnement afin d'assurer la cohérence entre les outils, les besoins opérationnels et les exigences de sécurité.", "CARTHY integrates license management into a comprehensive view of your environment to ensure consistency between tools, operational needs and security requirements."],
  ["Conformité SOC 2 et ISO 27001", "SOC 2 and ISO 27001 compliance"],
  ["Nous aidons les organisations à renforcer leur gouvernance de l'information, réduire les écarts de sécurité et mieux répondre aux attentes des clients, partenaires et auditeurs.", "We help organizations strengthen information governance, reduce security gaps and better meet the expectations of customers, partners and auditors."],
  ["Une intelligence artificielle privée exécutée localement afin que les données, les traitements et les connaissances de l'organisation demeurent sous contrôle interne.", "Private artificial intelligence running locally so the organization's data, processing and knowledge remain under internal control."],
  ["Une IA privée, locale et", "Private, local and"],
  ["souveraine", "sovereign"],
  ["CARTHY AI a été conçue pour les organisations qui souhaitent bénéficier de la puissance de l'intelligence artificielle sans dépendre d'une infrastructure infonuagique externe. Les modèles sont exécutés localement sur les serveurs ou l'environnement virtualisé de l'entreprise.", "CARTHY AI is designed for organizations that want the power of artificial intelligence without relying on external cloud infrastructure. Models run locally on the company's servers or virtualized environment."],
  ["Les données ne quittent jamais le périmètre de sécurité de l'organisation.", "Data never leaves the organization's security perimeter."],
  ["Découvrir CARTHY AI", "Discover CARTHY AI"],
  ["Les données sensibles et les connaissances internes restent dans l'environnement de l'organisation.", "Sensitive data and internal knowledge remain within the organization's environment."],
  ["Un agent local permet aux employés d'interagir naturellement avec l'IA de l'entreprise.", "A local agent allows employees to interact naturally with the company's AI."],
  ["Les accès peuvent être cloisonnés par département, équipe, fonction ou catégorie d'utilisateur.", "Access can be segmented by department, team, role or user category."],
  ["Les modèles peuvent être adaptés aux processus, à la terminologie et aux réalités métier.", "Models can be adapted to business processes, terminology and operational realities."],
  ["Préparer l'organisation à répondre à des exigences de sécurité plus élevées.", "Prepare the organization to meet higher security requirements."],
  ["Réduire les risques liés à la gouvernance des données et aux accès non autorisés.", "Reduce risks related to data governance and unauthorized access."],
  ["Soutenir la croissance commerciale grâce à une meilleure crédibilité auprès des clients et partenaires.", "Support business growth through stronger credibility with customers and partners."],
  ["Faites de la conformité un avantage opérationnel", "Turn compliance into an operational advantage"],
  ["À mesure que les audits deviennent plus rigoureux et que les attentes des clients augmentent, la conformité ne peut plus être traitée comme une simple formalité. CARTHY vous aide à structurer votre sécurité, démontrer votre maturité et bâtir une relation de confiance durable.", "As audits become more rigorous and customer expectations rise, compliance can no longer be treated as a formality. CARTHY helps you structure security, demonstrate maturity and build lasting trust."],
  ["Gouvernance et sécurité de l'information", "Information governance and security"],
  ["Secteurs desservis", "Industries served"],
  ["Des solutions adaptées aux secteurs les plus exigeants", "Solutions tailored to the most demanding industries"],
  ["CARTHY cible en priorité les organisations pour lesquelles la sécurité, la traçabilité et la conformité ont un impact direct sur les opérations et la réputation.", "CARTHY focuses on organizations where security, traceability and compliance have a direct impact on operations and reputation."],
  ["Protection des données, traçabilité et exigences élevées de gouvernance.", "Data protection, traceability and high governance requirements."],
  ["Confidentialité des informations et contrôle strict des accès.", "Information confidentiality and strict access control."],
  ["Sécurité, conformité et crédibilité auprès des clients et partenaires.", "Security, compliance and credibility with customers and partners."],
  ["Industrie et opérations critiques", "Industry and critical operations"],
  ["Résilience des systèmes et continuité des activités sensibles.", "System resilience and continuity of critical operations."],
  ["Notre méthode", "Our approach"],
  ["Une mise en œuvre structurée et progressive", "A structured and progressive implementation"],
  ["Une approche mesurable, adaptée à la réalité de l'organisation et conçue pour faire évoluer la sécurité, la conformité et l'infrastructure sans complexité inutile.", "A measurable approach tailored to the organization's reality and designed to improve security, compliance and infrastructure without unnecessary complexity."],
  ["Analyse des besoins et du niveau de maturité.", "Assessment of needs and maturity level."],
  ["Recommandations alignées sur les objectifs de sécurité et de conformité.", "Recommendations aligned with security and compliance objectives."],
  ["Mise en place des solutions et structuration des accès.", "Solution deployment and access structuring."],
  ["Optimisation continue selon les résultats et les besoins d'évolution.", "Continuous optimization based on results and evolving needs."],
  ["À propos de CARTHY", "About CARTHY"],
  ["CARTHY se positionne comme un acteur spécialisé en infrastructure, en gestion d'infrastructure informatique et en conformité organisationnelle. Notre offre est axée sur la fiabilité, la maîtrise des données et l'accompagnement des organisations dans des contextes où les exigences de sécurité sont élevées.", "CARTHY specializes in infrastructure, IT infrastructure management and organizational compliance. Our offering focuses on reliability, data control and supporting organizations in environments with high security requirements."],
  ["Notre différence", "What sets us apart"],
  ["L'intégration d'une IA privée locale et une expertise centrée sur SOC 2 et ISO 27001 afin de réunir infrastructure, sécurité, gouvernance et souveraineté des données dans une même approche.", "The integration of private local AI and expertise focused on SOC 2 and ISO 27001 bring infrastructure, security, governance and data sovereignty together in a single approach."],
  ["Échangeons", "Let's talk"],
  ["Parlons de votre infrastructure, de votre conformité et de vos données", "Let's talk about your infrastructure, compliance and data"],
  ["Que vous souhaitiez renforcer votre posture de sécurité, avancer vers une conformité reconnue ou déployer une IA privée dans votre environnement, CARTHY peut vous accompagner avec une approche structurée, sécurisée et adaptée à votre réalité d'affaires.", "Whether you want to strengthen your security posture, move toward recognized compliance or deploy private AI in your environment, CARTHY can support you with a structured, secure approach tailored to your business reality."],
  ["Demander une consultation", "Request a consultation"],
  ["Évaluer notre environnement", "Assess our environment"],
  ["Entreprise", "Company"],
  ["Référentiels", "Standards"],
  ["Infrastructure, conformité et intelligence artificielle privée pour les organisations qui veulent garder le contrôle de leurs données.", "Infrastructure, compliance and private artificial intelligence for organizations that want to stay in control of their data."],
  ["© 2026 CARTHY. Tous droits réservés.", "© 2026 CARTHY. All rights reserved."],
  ["Tous droits réservés.", "All rights reserved."],
  ["Confidentialité", "Privacy"],
  ["Conditions", "Terms"],
  ["Parlons de votre prochain projet.", "Let's talk about your next project."],
  ["Décrivez-nous votre besoin. Notre équipe vous répondra rapidement avec une première orientation claire.", "Tell us what you need. Our team will respond quickly with clear initial guidance."],
  ["Message envoyé", "Message sent"],
  ["Merci. Nous reviendrons vers vous dans les meilleurs délais.", "Thank you. We'll get back to you as soon as possible."],
  ["Envoyer un autre message", "Send another message"],
  ["Ne pas remplir :", "Do not fill in:"],
  ["Nom", "Name"],
  ["Votre nom", "Your name"],
  ["E-mail", "Email"],
  ["vous@entreprise.com", "you@company.com"],
  ["Nom de votre entreprise", "Your company name"],
  ["Parlez-nous de votre projet...", "Tell us about your project..."],
  ["Une erreur est survenue. Réessayez ou écrivez-nous directement.", "An error occurred. Please try again or email us directly."],
  ["Envoi...", "Sending..."],
  ["Envoyer le message", "Send message"],
]);

const normalize = (value) => (value || "").replace(/\s+/g, " ").trim();
const cleanFrench = (value) => normalize(value)
  .replace(/SOC 2 Type 1,\s*SOC 2 Type 2/g, "SOC 2 Type 2")
  .replace(/Type 1 et Type 2/g, "Type 2")
  .replace(/SOC 2 Type 1/g, "SOC 2");

const textState = new WeakMap();
const attributeState = new WeakMap();
let currentLanguage = localStorage.getItem(STORAGE_KEY) === "en" ? "en" : "fr";
let observer;

function captureText(node, force = false) {
  const raw = node.nodeValue || "";
  const previous = textState.get(node);
  if (!force && previous) return previous;
  if (force && previous && raw === previous.rendered) return previous;
  const leading = raw.match(/^\s*/)?.[0] || "";
  const trailing = raw.match(/\s*$/)?.[0] || "";
  const source = cleanFrench(raw);
  const state = { source, leading, trailing, rendered: raw };
  textState.set(node, state);
  return state;
}

function applyText(node, refreshSource = false) {
  if (!node || node.nodeType !== Node.TEXT_NODE) return;
  if (node.parentElement?.closest("[data-carthy-language-switcher]")) return;
  if (["SCRIPT", "STYLE"].includes(node.parentElement?.tagName)) return;
  const state = captureText(node, refreshSource);
  const translated = currentLanguage === "en" ? translations.get(state.source) : null;
  const value = `${state.leading}${translated || state.source}${state.trailing}`;
  if (node.nodeValue !== value) node.nodeValue = value;
  state.rendered = value;
}

function captureAttribute(element, attribute, refresh = false) {
  let map = attributeState.get(element);
  if (!map) {
    map = new Map();
    attributeState.set(element, map);
  }
  const current = element.getAttribute(attribute) || "";
  const previous = map.get(attribute);
  if (!refresh && previous) return previous;
  if (refresh && previous && current === previous.rendered) return previous;
  const source = cleanFrench(current);
  const state = { source, rendered: current };
  map.set(attribute, state);
  return state;
}

function applyAttributes(element, refreshSource = false) {
  if (!element?.hasAttribute) return;
  ["placeholder", "aria-label", "title", "alt"].forEach((attribute) => {
    if (!element.hasAttribute(attribute)) return;
    const state = captureAttribute(element, attribute, refreshSource);
    const translated = currentLanguage === "en" ? translations.get(state.source) : null;
    const value = translated || state.source;
    if (element.getAttribute(attribute) !== value) element.setAttribute(attribute, value);
    state.rendered = value;
  });
}

function applyTree(root, refreshSource = false) {
  if (!root) return;
  if (root.nodeType === Node.TEXT_NODE) {
    applyText(root, refreshSource);
    return;
  }
  if (root.nodeType !== Node.ELEMENT_NODE && root !== document.body) return;
  applyAttributes(root, refreshSource);
  root.querySelectorAll?.("[placeholder], [aria-label], [title], [alt]").forEach((el) => applyAttributes(el, refreshSource));
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (node.parentElement?.closest("[data-carthy-language-switcher]")) return NodeFilter.FILTER_REJECT;
      if (["SCRIPT", "STYLE"].includes(node.parentElement?.tagName)) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    },
  });
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach((node) => applyText(node, refreshSource));
}

function updateMetadata() {
  const english = currentLanguage === "en";
  document.documentElement.lang = english ? "en" : "fr";
  if (/^\/produits\/?$/.test(window.location.pathname)) {
    document.title = english
      ? "CARTHY Products | Servers and Workstations"
      : "Produits CARTHY | Serveurs et stations de travail";
    const description = english
      ? "Explore CARTHY hardware: GPU towers, rack servers with screen and keyboard, and 8-bay rack servers. Discuss the configuration for your project."
      : "Découvrez les équipements CARTHY : tour GPU, serveur rack avec écran et clavier et serveur rack 8 baies. Échangeons sur la configuration de votre projet.";
    document.querySelector('meta[name="description"]')?.setAttribute("content", description);
    document.querySelector('meta[property="og:title"]')?.setAttribute("content", document.title);
    document.querySelector('meta[property="og:description"]')?.setAttribute("content", description);
    document.querySelector('meta[name="twitter:title"]')?.setAttribute("content", document.title);
    document.querySelector('meta[name="twitter:description"]')?.setAttribute("content", description);
    return;
  }
  document.title = english ? "CARTHY | Infrastructure, compliance and private AI" : "CARTHY | Infrastructure, conformité et IA privée";
  const description = english
    ? "CARTHY supports businesses with infrastructure, IT infrastructure management, SOC 2 and ISO 27001 compliance, and private local artificial intelligence."
    : "CARTHY accompagne les entreprises en infrastructure, gestion d'infrastructure, conformité SOC 2 et ISO 27001, et intelligence artificielle privée locale.";
  document.querySelector('meta[name="description"]')?.setAttribute("content", description);
  document.querySelector('meta[property="og:title"]')?.setAttribute("content", document.title);
  document.querySelector('meta[property="og:description"]')?.setAttribute("content", english ? "Secure your infrastructure, structure your compliance and deploy private AI without exposing sensitive data." : "Sécurisez votre infrastructure, structurez votre conformité et déployez une IA privée sans exposer vos données sensibles.");
  document.querySelector('meta[name="twitter:title"]')?.setAttribute("content", document.title);
  document.querySelector('meta[name="twitter:description"]')?.setAttribute("content", english ? "Infrastructure, SOC 2 and ISO 27001 compliance, infrastructure management and private local artificial intelligence." : "Infrastructure, conformité SOC 2 et ISO 27001, gestion d'infrastructure et intelligence artificielle privée locale.");
}

function updateSwitcherState() {
  document.querySelectorAll("[data-carthy-language-switcher]").forEach((switcher) => {
    switcher.dataset.active = currentLanguage;
    switcher.querySelectorAll("button[data-lang]").forEach((button) => {
      const active = button.dataset.lang === currentLanguage;
      button.setAttribute("aria-pressed", String(active));
      button.tabIndex = active ? -1 : 0;
    });
  });
}

function makeSwitcher(mode) {
  const wrapper = document.createElement("div");
  wrapper.dataset.carthyLanguageSwitcher = mode;
  wrapper.dataset.active = currentLanguage;
  wrapper.className = `carthy-language-switcher carthy-language-switcher--${mode}`;
  wrapper.setAttribute("role", "group");
  wrapper.setAttribute("aria-label", "Language / Langue");
  ["fr", "en"].forEach((lang) => {
    const button = document.createElement("button");
    button.type = "button";
    button.dataset.lang = lang;
    button.textContent = lang.toUpperCase();
    button.setAttribute("aria-label", lang === "fr" ? "Français" : "English");
    button.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      setLanguage(lang);
    });
    wrapper.appendChild(button);
  });
  return wrapper;
}

function ensureSwitchers() {
  const header = document.querySelector('[data-testid="navbar"]');
  if (!header) return;
  const nav = header.querySelector("nav");
  if (nav && !nav.querySelector('[data-carthy-language-switcher="desktop"]')) nav.appendChild(makeSwitcher("desktop"));
  const topRow = header.firstElementChild;
  const mobileMenuButton = topRow?.querySelector('button[aria-label="Ouvrir le menu"], button[aria-label="Open menu"]');
  if (topRow && mobileMenuButton && !topRow.querySelector('[data-carthy-language-switcher="mobile"]')) topRow.insertBefore(makeSwitcher("mobile"), mobileMenuButton);
  updateSwitcherState();
}

function fixEmailReferences() {
  document.querySelectorAll('a[href^="mailto:contact@carthy.io"]').forEach((link) => {
    link.href = link.href.replace("contact@carthy.io", "info@carthyai.com");
  });
  document.querySelectorAll("a").forEach((link) => {
    if (normalize(link.textContent) === "contact@carthy.io") link.textContent = "info@carthyai.com";
  });
}

function setLanguage(language) {
  const next = language === "en" ? "en" : "fr";
  if (next === currentLanguage) return;
  currentLanguage = next;
  localStorage.setItem(STORAGE_KEY, currentLanguage);
  applyTree(document.body, false);
  updateMetadata();
  updateSwitcherState();
  window.dispatchEvent(new CustomEvent("carthy-language-change", { detail: { language: currentLanguage } }));
}

function handleMutations(mutations) {
  mutations.forEach((mutation) => {
    if (mutation.type === "characterData") {
      applyText(mutation.target, true);
      return;
    }
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) applyText(node, false);
      if (node.nodeType === Node.ELEMENT_NODE) applyTree(node, false);
    });
  });
  ensureSwitchers();
  fixEmailReferences();
}

function boot() {
  applyTree(document.body, false);
  updateMetadata();
  ensureSwitchers();
  fixEmailReferences();
  observer = new MutationObserver(handleMutations);
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
